<template>
    <div class="agreement">
        <div class="main_wrap">
			<h2 class="agreement_title">用户协议列表</h2>
			<div class="agreement_list">
				<el-card class="box-card">
				  <div v-for="item in agreementListInfo" :key="item.id">
				    <p class="card-p" @click.stop.prevent="userAgreement(item)">{{item.title}}</p>
				  </div>
				</el-card>
			</div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { getBaseUrl } from '@/utils/baseUrl.js'
import axios from 'axios'
export default {
    name: 'Agreement',
    data() {
        return {
			agreementStatus: [],
			agreementListInfo: [],
			update_time: ''
        }
    },
    created() {
        this.getAgreementList()
    },
    methods: {
        ...mapActions('withdrawal', ['agreementList']),
       async getAgreementList() {
			let res = await this.agreementList({type:1})
			console.log('getAgreementList',res)
			this.agreementListInfo = res.list
			this.update_time = res.update_time
       },
	   checkAgreementStatus(data){
			console.log(data,this.agreementStatus);
	   },
	   userAgreement(data){
			// 跳转路由
			window.open(`/agreementPages?id=${data.id}&time=${this.update_time}`)
	   },
    }
}
</script>
<style lang="less" scoped>
    .main_wrap {
		background-color: #fff;
		padding: 20px;
		border-radius: 5px;
		box-sizing: border-box;
		position: relative;
		min-height: 550px;
	}
	.agreement_title{
		text-align: center;
		margin-bottom: 20px;
	}
	.agreement_list{
		text-align: center;
		margin-bottom: 20px;
		width: 800px;
		margin: 0 auto
		
	}
	.card-p{
		margin-bottom: 20px;
		color: #409EFF;
		cursor: pointer;
	}
</style>
